module.exports = __webpack_public_path__ + "img/kothari.d04aaa4d.png";